import styled from '@emotion/styled';
import { EntityEventLabels, type EntityEventType } from '@racemap/sdk/schema/entityEvents';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Select, type SelectProps, Tag } from 'antd';
import { type FC, useEffect, useState } from 'react';
import { entityEventColorMap } from 'src/components/MonitorBeta/utils/entityEventColorMap';

type Props = {
  value?: Array<EntityEventType>;
  onChange?: (selected: Array<EntityEventType>) => void;
  possibleEventTypes?: Array<EntityEventType>;
};

export const EntityEventsSelect: FC<Props> = ({ value, onChange, possibleEventTypes }) => {
  const [selectedEvents, setSelectedEvents] = useState<Array<EntityEventType>>(value ?? []);

  useEffect(() => {
    if (value !== undefined) {
      setSelectedEvents(value);
    }
  }, [value]);

  const handleChange = (values: Array<EntityEventType>) => {
    setSelectedEvents(values);
    onChange?.(values);
  };

  const options: SelectProps['options'] = Object.entries(EntityEventLabels)
    .filter(([key]) => !possibleEventTypes || possibleEventTypes.includes(key as EntityEventType))
    .map(([key, label]) => ({
      label,
      value: key as EntityEventType,
    }));

  const tagRender: SelectProps['tagRender'] = (props) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <StatusTag
        color={entityEventColorMap[value] || RacemapColors.LightGray}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
      >
        {label}
      </StatusTag>
    );
  };

  return (
    <Select
      mode="multiple"
      placeholder="Select an Event Type"
      tagRender={tagRender}
      options={options}
      value={selectedEvents}
      onChange={handleChange}
      style={{ width: '100%' }}
    />
  );
};

const StatusTag = styled(Tag)`
    margin: 4px 4px;
`;
